module.exports = __webpack_public_path__ + "static/img/240_TO8_2174_og.80b9873.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/240_TO8_2174_og.jpg
// module id = Oyyf
// module chunks = 0